// @ts-nocheck
(() => {

  const CART_UPDATE_EVENT = 'cart:update';

  const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const fetchCart = async () => {
    const res = await fetch(`${cartRoot}cart.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return res.json();
  };

  const buildCartQtyMap = (cart) => {
    const map = {};
    const items = Array.isArray(cart?.items) ? cart.items : [];
    items.forEach((it) => {
      const id = it?.variant_id;
      if (!id) return;
      map[String(id)] = (map[String(id)] || 0) + (Number(it?.quantity) || 0);
    });
    return map;
  };

  const syncHeaderCartCount = (count) => {
    document.dispatchEvent(
      new CustomEvent(CART_UPDATE_EVENT, {
        bubbles: true,
        detail: {
          data: {
            itemCount: Number(count) || 0,
            source: 'beambox-buy-modal',
          },
        },
      })
    );
  };

  const incrementHeaderCartCount = (delta) => {
    document.dispatchEvent(
      new CustomEvent(CART_UPDATE_EVENT, {
        bubbles: true,
        detail: {
          data: {
            itemCount: Number(delta) || 0,
            source: 'product-form-component',
          },
        },
      })
    );
  };

  const formatMoney = (cents, locale, currency) => {
    const value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(locale || undefined, {
        style: 'currency',
        currency: currency || undefined,
      }).format(value);
    } catch (_) {
      return `$${value.toFixed(2)}`;
    }
  };

  const isColorLike = (name) => {
    const n = String(name || '').toLowerCase();
    return n.includes('color') || n.includes('colour') || n.includes('finish') || n.includes('颜色') || n.includes('色') || n === '颜色';
  };

  const isModelLike = (name) => String(name || '').toLowerCase().includes('model');

  const isValidCssColor = (value) => {
    if (!value) return false;
    if (!window.CSS || !window.CSS.supports) return false;
    return CSS.supports('color', String(value));
  };

  const getInventoryMax = (variant) => {
    if (!variant) return null;

    // Only enforce a max when Shopify is tracking inventory.
    // Typical Shopify behavior: when inventory_policy is 'deny', you cannot oversell.
    // If you want to ALWAYS cap to inventory even when policy is 'continue', change the check below.
    const isTracked = !!variant.inventoryManagement;
    const policy = String(variant.inventoryPolicy || '').toLowerCase();
    const qty = Number(variant.inventoryQuantity);

    if (!isTracked) return null;
    if (!Number.isFinite(qty)) return null;
    if (policy && policy !== 'deny') return null;

    return Math.max(0, Math.floor(qty));
  };

  const clampInt = (value, min, max) => {
    const n = Number.parseInt(String(value ?? ''), 10);
    const safe = Number.isFinite(n) ? n : min;
    const withMin = Math.max(min, safe);
    if (typeof max === 'number' && Number.isFinite(max)) return Math.min(withMin, max);
    return withMin;
  };

  const findVariant = (variants, selectedOptions) => {
    if (!Array.isArray(variants)) return null;
    const exact = variants.filter((v) => Array.isArray(v.options) && v.options.join('||') === selectedOptions.join('||'));

    if (exact.length) {
      const available = exact.find((v) => v.available);
      return available || exact[0];
    }

    // Fallback: progressively relax to the first matching prefix.
    for (let i = selectedOptions.length; i >= 1; i -= 1) {
      const prefix = selectedOptions.slice(0, i).join('||');
      const matches = variants.filter((v) => Array.isArray(v.options) && v.options.slice(0, i).join('||') === prefix);
      if (matches.length) {
        const available = matches.find((v) => v.available);
        return available || matches[0];
      }
    }

    const availableAny = variants.find((v) => v.available);
    return availableAny || variants[0] || null;
  };

  const getValueVariants = (variants, optionIndex, value, currentSelectedOptions) => {
    // Try keep other options same; if none found, fall back to any variant with that value.
    const sameOthers = variants.filter((v) => {
      if (!Array.isArray(v.options) || v.options.length <= optionIndex) return false;
      if (v.options[optionIndex] !== value) return false;
      for (let i = 0; i < currentSelectedOptions.length; i += 1) {
        if (i === optionIndex) continue;
        if (currentSelectedOptions[i] && v.options[i] !== currentSelectedOptions[i]) return false;
      }
      return true;
    });

    if (sameOthers.length) return sameOthers;

    return variants.filter((v) => Array.isArray(v.options) && v.options[optionIndex] === value);
  };

  const setupModal = (dialog) => {
    if (!(dialog instanceof HTMLDialogElement)) return;
    if (dialog.dataset.beamboxBuyReady === 'true') return;

    const dataEl = dialog.querySelector('script[data-beambox-buy-data]');
    if (!dataEl) return;

    let data;
    try {
      data = JSON.parse(dataEl.textContent || '{}');
    } catch (_) {
      return;
    }


    const product = data.product || {};
    const optionNames = Array.isArray(data.optionNames) ? data.optionNames : [];
    const optionsWithValues = Array.isArray(data.optionsWithValues) ? data.optionsWithValues : [];
    const variants = Array.isArray(data.variants) ? data.variants : [];


    const optionsRoot = dialog.querySelector('[data-beambox-buy-options]');
    const imgEl = dialog.querySelector('[data-beambox-buy-image]');
    const priceEl = dialog.querySelector('[data-beambox-buy-price]');
    const qtyEl = dialog.querySelector('[data-beambox-buy-quantity]');
    const addBtn = dialog.querySelector('[data-beambox-buy-add]');
    const closeBtn = dialog.querySelector('[data-beambox-buy-close]');
    const errorEl = dialog.querySelector('[data-beambox-buy-error]');

    if (!optionsRoot || !priceEl || !addBtn) return;

    const updateOpenStateClass = () => {
      const anyOpen = document.querySelector('dialog[data-beambox-buy-modal][open]');
      document.documentElement.classList.toggle('beambox-buy-modal-open', !!anyOpen);
    };

    const initialById = variants.find((v) => String(v.id) === String(data.initialVariantId));
    // Prefer an available variant on open; if the initial variant is sold out,
    // default to the first available one so the button is actionable.
    const initialVariant =
      (initialById && initialById.available ? initialById : null) ||
      variants.find((v) => v.available) ||
      initialById ||
      variants[0];

    const state = {
      selectedOptions: Array.isArray(initialVariant?.options) ? [...initialVariant.options] : optionNames.map(() => ''),
      variant: initialVariant || null,
      cartQtyByVariantId: {},
      errorMessage: '',
    };

    const defaultAddLabel = (addBtn.textContent || '').trim() || 'Add to Bag';

    const clearError = () => {
      state.errorMessage = '';
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    };

    const render = () => {
      const variant = findVariant(variants, state.selectedOptions);
      state.variant = variant;

      // Keep quantity within available inventory when applicable.
      if (qtyEl) {
        const invMax = getInventoryMax(variant);
        const inCart = typeof invMax === 'number' ? Number(state.cartQtyByVariantId[String(variant?.id)] || 0) : 0;
        const remaining = typeof invMax === 'number' ? Math.max(0, invMax - inCart) : null;
        const qtyMax = typeof remaining === 'number' ? remaining : invMax;

        if (typeof qtyMax === 'number') {
          qtyEl.setAttribute('max', String(qtyMax));
          qtyEl.value = String(clampInt(qtyEl.value, 1, qtyMax));
          qtyEl.disabled = qtyMax <= 0;
        } else {
          qtyEl.removeAttribute('max');
          qtyEl.value = String(clampInt(qtyEl.value, 1));
          qtyEl.disabled = false;
        }
      }

      if (priceEl) {
        priceEl.textContent = formatMoney(variant?.price, product.locale, product.currency);
      }

      if (imgEl && variant?.image) {
        imgEl.src = variant.image;
      } else if (imgEl && product.featuredImage) {
        imgEl.src = product.featuredImage;
      }

      if (addBtn) {
        const invMax = getInventoryMax(variant);
        const inCart = typeof invMax === 'number' ? Number(state.cartQtyByVariantId[String(variant?.id)] || 0) : 0;
        const remaining = typeof invMax === 'number' ? Math.max(0, invMax - inCart) : null;

        const hasRemaining = typeof remaining === 'number' ? remaining > 0 : true;
        const isAvailable = !!(variant && variant.available);
        const canAdd = isAvailable && hasRemaining;

        addBtn.disabled = !canAdd;
        addBtn.setAttribute('aria-disabled', canAdd ? 'false' : 'true');

        if (!isAvailable) {
          addBtn.textContent = 'Sold out';
        } else if (!hasRemaining) {
          addBtn.textContent = 'Sold out';
        } else {
          addBtn.textContent = defaultAddLabel;
        }
      }

      if (errorEl) {
        if (state.errorMessage) {
          errorEl.hidden = false;
          errorEl.textContent = state.errorMessage;
        } else {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
      }

      // Update pressed state
      optionNames.forEach((name, idx) => {
        const group = optionsRoot.querySelector(`[data-option-index="${idx}"]`);
        if (!group) return;
        const buttons = group.querySelectorAll('button[data-option-value]');
        buttons.forEach((btn) => {
          const val = btn.getAttribute('data-option-value') || '';
          btn.setAttribute('aria-pressed', val === state.selectedOptions[idx] ? 'true' : 'false');
        });
      });
    };

    const buildOptionGroup = (name, optionIndex) => {
      const group = document.createElement('div');
      group.className = 'beambox-buy-modal__option';
      group.setAttribute('data-option-index', String(optionIndex));

      if (isModelLike(name)) {
        group.setAttribute('data-option-type', 'model');
      } else if (isColorLike(name)) {
        group.setAttribute('data-option-type', 'color');
      } else {
        group.setAttribute('data-option-type', 'default');
      }

      const title = document.createElement('div');
      title.className = 'beambox-buy-modal__option-title';
      title.textContent = name;
      group.appendChild(title);

      const valuesWrap = document.createElement('div');
      valuesWrap.className = 'beambox-buy-modal__values';

      const values = Array.from(new Set(variants.map((v) => (Array.isArray(v.options) ? v.options[optionIndex] : null)).filter(Boolean)));

      const baseVariant = findVariant(variants, state.selectedOptions);
      const basePrice = baseVariant?.price ?? 0;

      values.forEach((value) => {
        const valueVariants = getValueVariants(variants, optionIndex, value, state.selectedOptions);
        const preferred = valueVariants.find((v) => v.available) || valueVariants[0];

        if (isModelLike(name)) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'beambox-buy-modal__model';
          btn.setAttribute('data-option-value', value);
          btn.setAttribute('aria-pressed', 'false');

          const row = document.createElement('div');
          row.className = 'beambox-buy-modal__model-row';

          const left = document.createElement('div');
          left.className = 'beambox-buy-modal__model-left';

          const titleEl = document.createElement('div');
          titleEl.className = 'beambox-buy-modal__model-title';
          titleEl.textContent = value;

          const subtitleEl = document.createElement('div');
          subtitleEl.className = 'beambox-buy-modal__model-subtitle';
          // Optional: can be wired to metafields later.
          subtitleEl.textContent = '';

          left.appendChild(titleEl);
          left.appendChild(subtitleEl);

          const right = document.createElement('div');
          right.className = 'beambox-buy-modal__model-delta';

          const price = preferred?.price ?? basePrice;
          const delta = price - basePrice;
          if (delta > 0) {
            right.textContent = `+${formatMoney(delta, product.locale, product.currency)}`;
          } else {
            right.textContent = '';
          }

          row.appendChild(left);
          row.appendChild(right);
          btn.appendChild(row);

          btn.addEventListener('click', () => {
            clearError();
            state.selectedOptions[optionIndex] = value;
            render();
          });

          valuesWrap.appendChild(btn);
          return;
        }

        if (isColorLike(name)) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'beambox-buy-modal__swatch';
          btn.setAttribute('data-option-value', value);
          btn.setAttribute('aria-pressed', 'false');

          const dot = document.createElement('span');
          dot.className = 'beambox-buy-modal__swatch-dot';
          
          // Try to get swatch data from optionsWithValues
          let swatchColor = null;
          let swatchImage = null;
          if (optionsWithValues.length > optionIndex) {
            const optionData = optionsWithValues[optionIndex];
            const valueData = optionData.values?.find(v => v.name === value);
            if (valueData) {
              swatchColor = valueData.swatchColor;
              swatchImage = valueData.swatchImage;
            }
          }
          
          // Apply swatch styling
          if (swatchImage) {
            dot.style.backgroundImage = `url(${swatchImage})`;
            dot.style.backgroundSize = 'cover';
            dot.style.backgroundPosition = 'center';
          } else if (swatchColor) {
            const colorStyle = `rgb(${swatchColor})`;
            dot.style.backgroundColor = colorStyle;
          } else if (isValidCssColor(value)) {
            dot.style.backgroundColor = value;
          } else {
            console.log('没有应用任何颜色');
          }

          const label = document.createElement('span');
          label.className = 'beambox-buy-modal__swatch-label';
          label.textContent = value;

          btn.appendChild(dot);
          btn.appendChild(label);

          btn.addEventListener('click', () => {
            clearError();
            state.selectedOptions[optionIndex] = value;
            // Prefer switching to a variant with this option's image (if present)
            if (preferred?.image) {
              // keep render() to re-find exact variant across options
            }
            render();
          });

          valuesWrap.appendChild(btn);
          return;
        }

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'beambox-buy-modal__pill';
        btn.textContent = value;
        btn.setAttribute('data-option-value', value);
        btn.setAttribute('aria-pressed', 'false');
        btn.addEventListener('click', () => {
          clearError();
          state.selectedOptions[optionIndex] = value;
          render();
        });
        valuesWrap.appendChild(btn);
      });

      group.appendChild(valuesWrap);
      return group;
    };

    // Build DOM once
    optionsRoot.textContent = '';
    optionNames.forEach((name, idx) => {
      optionsRoot.appendChild(buildOptionGroup(name, idx));
    });

    const closeDialog = () => {
      try {
        dialog.close();
      } catch (_) {
        // no-op
      }

      // Ensure the root class is removed after close.
      updateOpenStateClass();
    };

    closeBtn?.addEventListener('click', closeDialog);

    qtyEl?.addEventListener('input', () => {
      clearError();
      const invMax = getInventoryMax(state.variant);
      const inCart = typeof invMax === 'number' ? Number(state.cartQtyByVariantId[String(state.variant?.id)] || 0) : 0;
      const remaining = typeof invMax === 'number' ? Math.max(0, invMax - inCart) : null;
      const maxNow = typeof remaining === 'number' ? remaining : invMax;
      qtyEl.value = String(clampInt(qtyEl.value, 1, maxNow ?? undefined));
    });

    dialog.addEventListener('click', (e) => {
      // Only close when clicking the backdrop (not inside the panel)
      if (e.target === dialog) closeDialog();
    });

    dialog.addEventListener('cancel', (e) => {
      // prevent default to control close
      e.preventDefault();
      closeDialog();
    });

    addBtn.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const variant = state.variant;

      // Note: when the button is disabled (sold out), browsers won't dispatch click events.
      if (!variant || !variant.id) return;

      let qty = Math.max(1, Number.parseInt(qtyEl?.value || '1', 10) || 1);

      // First clamp against variant inventory (if applicable).
      const invMax = getInventoryMax(variant);
      if (typeof invMax === 'number') {
        qty = Math.min(qty, invMax);
        if (qtyEl) qtyEl.value = String(qty);
      }

      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      try {
        // Second clamp against remaining inventory considering what's already in cart.
        if (typeof invMax === 'number') {
          const cart = await fetchCart();
          state.cartQtyByVariantId = buildCartQtyMap(cart);

          const inCart = Number(state.cartQtyByVariantId[String(variant.id)] || 0);

          const remaining = Math.max(0, invMax - inCart);
          if (remaining <= 0) {
            state.errorMessage = 'No more stock available for this option.';
            render();
            return;
          }

          if (qty > remaining) {
            qty = remaining;
            if (qtyEl) qtyEl.value = String(qty);
          }
        }

        const formData = new FormData();
        formData.append('id', String(variant.id));
        formData.append('quantity', String(qty));

        const addRes = await fetch(`${cartRoot}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: formData,
        });

        if (!addRes.ok) throw new Error('Failed to add to cart');

        // Update local cart-qty cache so a subsequent open can reflect remaining stock immediately.
        state.cartQtyByVariantId[String(variant.id)] = Number(state.cartQtyByVariantId[String(variant.id)] || 0) + qty;

        incrementHeaderCartCount(qty);

        // Reconcile exact count in background
        const reconcile = async () => {
          try {
            const cart = await fetchCart();
            syncHeaderCartCount(cart.item_count);
          } catch (_) {
            // no-op
          }
        };

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(reconcile, { timeout: 2000 });
        } else {
          window.setTimeout(reconcile, 0);
        }

        closeDialog();
      } catch (err) {
        state.errorMessage = 'Add to cart failed. Please try again.';
      } finally {
        addBtn.removeAttribute('aria-busy');
        render();
      }
    });

    dialog.dataset.beamboxBuyReady = 'true';
    render();

    // Load cart quantities so we can disable Add to Bag when stock is already in cart.
    // This avoids the "can still click but nothing happens" feeling on low-stock items.
    const hydrateCartQty = async () => {
      try {
        const cart = await fetchCart();
        state.cartQtyByVariantId = buildCartQtyMap(cart);
        render();
      } catch (_) {
        // no-op
      }
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(hydrateCartQty, { timeout: 1500 });
    } else {
      window.setTimeout(hydrateCartQty, 0);
    }

    // Keep root state in sync even if dialog is closed externally.
    dialog.addEventListener('close', updateOpenStateClass);
  };

  const openModalForHandle = (handle) => {
    const all = Array.from(document.querySelectorAll('dialog[data-beambox-buy-modal]'));
    const dialog = all.find((el) => el instanceof HTMLDialogElement && el.getAttribute('data-product-handle') === handle);

    if (!(dialog instanceof HTMLDialogElement)) {
      console.warn('[beambox-buy-modal] dialog not found for handle', handle, { dialogs: all.length });
      return null;
    }

    setupModal(dialog);

    try {
      dialog.showModal();
    } catch (_) {
      // If already open, no-op
    }

    document.documentElement.classList.add('beambox-buy-modal-open');


    return dialog;
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-beambox-buy-trigger]') : null;
    if (!target) return;


    const handle = target.getAttribute('data-product-handle');
    if (!handle) return;

    const dialog = openModalForHandle(handle);
    if (!dialog) return;

    event.preventDefault();
  });
})();
